module.exports = __webpack_public_path__ + "static/img5-26d4fbda7d994c7abf29bbce623c42f3.png";